export default "__VITE_ASSET__8Ah3lv7P__"